export const UPDATE_SEARCHDATA_GOIVAY = "UPDATE_SEARCHDATA_GOIVAY";